import { aboutData } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          关于我们
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          了解黑料官网的定位与价值
        </p>

        <div className="max-w-3xl mx-auto">
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8 text-center">
            {aboutData.description}
          </p>

          <div className="flex flex-wrap items-center justify-center gap-8 md:gap-16">
            {aboutData.stats.map((stat, i) => (
              <div key={i} className="flex flex-col items-center gap-1">
                <span className="text-2xl md:text-3xl font-bold text-accent-500">{stat.value}</span>
                <span className="text-xs md:text-sm text-foreground-500">{stat.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}